import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Divider } from '@mui/material'
import moment from 'moment'

import { withStyles } from '@mui/styles'
import { style } from 'styles'
import { InputSelect, InputText } from 'components'

function GuestUserData({ compulsoryData, isShippable, selectedShippingMethodId }) {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const userGuest = useSelector(state => state.userGuest)
	const shop = useSelector(state => state.shop)
	const collectDateTimeProfile = Number(shop.profiles.ueby_collect_date_time)
	const userBillRequestProfile = Number(shop.profiles.ueby_user_bill_request)
	const needCollectData = [4,5].includes(Number(selectedShippingMethodId))

	useEffect(() => {
		// Imposto la data di oggi come default per il ritiro
		if (collectDateTimeProfile > 0) {
			dispatch({ type: 'editData@userGuest', field: 'collect_date', value: moment().format('YYYY-MM-DD') })
		} else {
			dispatch({ type: 'editData@userGuest', field: 'collect_date', value: null })
			dispatch({ type: 'editData@userGuest', field: 'collect_time', value: null })
		}
	}, [])

	useEffect(() => {
		if (selectedShippingMethodId == 6) {
			// Se ho scelto la spedizione internazionale annullo il valore della provincia
			dispatch({ type: 'editData@userGuest', field: 'bill_province_id', value: null })
			dispatch({ type: 'editData@userGuest', field: 'ship_province_id', value: null })
		} else {
			// Altrimenti annullo il valore della nazione
			dispatch({ type: 'editData@userGuest', field: 'bill_country_id', value: null })
			dispatch({ type: 'editData@userGuest', field: 'ship_country_id', value: null })
		}
	}, [selectedShippingMethodId])

	const handleFormValueChange = (e) => {
		dispatch({ type: 'editData@userGuest', field: e.target.name, value: e.target.value })

		if (e.target.name.substr(0,5) == 'ship_' && !userGuest.bill_flag) {
			const field = e.target.name.substring(5)
			dispatch({ type: 'editData@userGuest', field: `bill_${field}`, value: e.target.value })
		}
	}

	return (<div className="box">
		<h4>Dati del cliente</h4>
		<InputText
			label='Nome'
			name='name'
			onChange={handleFormValueChange}
			value={userGuest.name || ''}
			compulsoryData={compulsoryData}
		/>
		<InputText
			label='Cognome'
			name='surname'
			onChange={handleFormValueChange}
			value={userGuest.surname || ''}
			compulsoryData={compulsoryData}
		/>
		<InputText
			label='EMail'
			name='email'
			type="email"
			onChange={handleFormValueChange}
			value={userGuest.email || ''}
			compulsoryData={compulsoryData}
		/>
		<InputText
			label='Cellulare'
			name='mobile'
			type="phone"
			onChange={handleFormValueChange}
			value={userGuest.mobile || ''}
			compulsoryData={compulsoryData}
		/>
		{Number(shop.profiles.ueby_conventions_mode) == 3 && <React.Fragment>
			<h5>Convenzione</h5>
			<InputText
				label='Azienda convenzionata'
				name='convention'
				onChange={handleFormValueChange}
				value={userGuest.convention || ''}
				compulsoryData={compulsoryData}
			/>
		</React.Fragment>}

		{needCollectData && collectDateTimeProfile > 0 && <React.Fragment>
			<h5>{selectedShippingMethodId == 4 ? 'Consegna' : 'Ritiro'} della merce</h5>
			<InputText
				label={selectedShippingMethodId == 4 ? 'Data di consegna' : 'Data del ritiro'}
				name='collect_date'
				type='date'
				onChange={handleFormValueChange}
				value={userGuest.collect_date || ''}
				compulsoryData={compulsoryData}
				disabled={collectDateTimeProfile != 2}
			/>
			<InputText
				label={selectedShippingMethodId == 4 ? 'Ora di consegna indicativa' : 'Ora del ritiro'}
				name='collect_time'
				type='time'
				onChange={handleFormValueChange}
				value={userGuest.collect_time || ''}
				compulsoryData={compulsoryData}
			/>
		</React.Fragment>}

		{!!isShippable && <React.Fragment>
			<h5>{`Indirizzo di ${selectedShippingMethodId == 2 ? 'spedizione' : 'consegna'}`}</h5>
			<InputText
				label='Indirizzo'
				name='ship_address'
				onChange={handleFormValueChange}
				value={userGuest.ship_address || ''}
				compulsoryData={compulsoryData}
			/>
			<InputText
				label='N. civico'
				name='ship_house_number'
				onChange={handleFormValueChange}
				value={userGuest.ship_house_number || ''}
				compulsoryData={compulsoryData}
			/>
			<InputText
				label='C.a.p.'
				name='ship_postal_code'
				onChange={handleFormValueChange}
				value={userGuest.ship_postal_code || ''}
				compulsoryData={compulsoryData}
				maxLength="5"
			/>
			<InputText
				label='Comune'
				name='ship_city'
				onChange={handleFormValueChange}
				value={userGuest.ship_city || ''}
				compulsoryData={compulsoryData}
			/>
			{Number(selectedShippingMethodId) != 6 && <InputSelect
				label='Provincia'
				value={userGuest.ship_province_id || ''}
				onChange={handleFormValueChange}
				name='ship_province_id'
				groupped
				options={shop.shipping_regions}
				groupLabel={v => v.name}
				optionValue={v => v.province_id}
				optionLabel={v => v.name}
			/>}
			{Number(selectedShippingMethodId) == 6 && <InputSelect
				label='Nazione'
				value={userGuest.ship_country_id || ''}
				onChange={handleFormValueChange}
				name='ship_country_id'
				options={shop.countries}
				groupLabel={v => v.name}
				optionValue={v => v.country_id}
				optionLabel={v => v.name}
				compulsoryData={compulsoryData}
			/>}
		</React.Fragment>}

		{userBillRequestProfile == 1 && <React.Fragment>
			<Divider style={{ margin: '24px 0 10px 0' }}/>
			<p>
				<label><input type="checkbox" name="bill_flag" value="1" checked={!!userGuest.bill_flag} onChange={(e) => dispatch({ type: 'editData@userGuest', field: e.target.name, value: e.target.checked })} /> Richiedi fattura</label>
			</p>
			{!!userGuest.bill_flag && <React.Fragment>
				<h5>Dati di fatturazione</h5>
				<InputText
					label='Ragione sociale *'
					name='company'
					onChange={handleFormValueChange}
					value={userGuest.company || ''}
					compulsoryData={compulsoryData}
				/>
				<InputText
					label='Partita iva **'
					name='piva'
					onChange={handleFormValueChange}
					value={userGuest.piva || ''}
					compulsoryData={compulsoryData}
				/>
				<InputText
					label='Codice fiscale **'
					name='cf'
					onChange={handleFormValueChange}
					value={userGuest.cf || ''}
					compulsoryData={compulsoryData}
				/>
				<InputText
					label='Codice destinatario fattura elettronica'
					name='e_inv_dest_code'
					onChange={handleFormValueChange}
					value={userGuest.e_inv_dest_code || ''}
					compulsoryData={compulsoryData}
				/>
				<InputText
					label='Pec per invio fattura elettronica'
					name='e_inv_pec'
					onChange={handleFormValueChange}
					value={userGuest.e_inv_pec || ''}
					compulsoryData={compulsoryData}
				/>
				<InputText
					label='Indirizzo *'
					name='bill_address'
					onChange={handleFormValueChange}
					value={userGuest.bill_address || ''}
					compulsoryData={compulsoryData}
				/>
				<InputText
					label='N. civico *'
					name='bill_house_number'
					onChange={handleFormValueChange}
					value={userGuest.bill_house_number || ''}
					compulsoryData={compulsoryData}
				/>
				<InputText
					label='C.a.p. *'
					name='bill_postal_code'
					onChange={handleFormValueChange}
					value={userGuest.bill_postal_code || ''}
					compulsoryData={compulsoryData}
					maxLength="5"
				/>
				<InputText
					label='Comune *'
					name='bill_city'
					onChange={handleFormValueChange}
					value={userGuest.bill_city || ''}
					compulsoryData={compulsoryData}
				/>
				{Number(selectedShippingMethodId) != 6 && <InputSelect
					label='Provincia'
					value={userGuest.bill_province_id || ''}
					onChange={handleFormValueChange}
					name='bill_province_id'
					groupped
					options={shop.regions}
					groupLabel={v => v.name}
					optionValue={v => v.province_id}
					optionLabel={v => v.name}
				/>}
				{Number(selectedShippingMethodId) == 6 && <InputSelect
					label='Nazione'
					value={userGuest.bill_country_id || ''}
					onChange={handleFormValueChange}
					name='bill_country_id'
					options={shop.countries}
					groupLabel={v => v.name}
					optionValue={v => v.country_id}
					optionLabel={v => v.name}
				/>}
				<p><small>(**) compilare almeno uno dei due campi</small></p>
			</React.Fragment>}
		</React.Fragment>}
	</div>)
}

export default withStyles(style)(GuestUserData)
